import { render } from "./chinaMap2.vue?vue&type=template&id=08bfa3f6&scoped=true"
import script from "./chinaMap2.vue?vue&type=script&lang=js"
export * from "./chinaMap2.vue?vue&type=script&lang=js"

import "./chinaMap2.vue?vue&type=style&index=0&id=08bfa3f6&scoped=true&lang=css"

import exportComponent from "D:\\项目\\王守岩代码\\长护险\\小爱到家长护险服务运营平台4.8\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bfa3f6"]])

export default __exports__